<template>
  <div id="AddPaShadowing" class="wrap">
     <v-app-bar  class="grey lighten-3 hidden-md-and-up"  fixed  elevate-on-scroll  >
      <v-layout justify-center align-center>
        <span class="title blue--text text--darken-3 ml-1"> Add Physician Assistant</span>
      </v-layout>
    </v-app-bar>

    <div class="maxContainer">
      <div class="offset-md-3 col-md-6 offset-sm-2 col-sm-8">
        <div @click="backDesktop" class="headerFake__back">
          <a class="headerFake__backLink">
            <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
            <span class="headerFake__backText">Back</span>
          </a>
        </div>
      </div>
      <v-card class=" mb-5 pt-5 offset-md-3 col-md-6 offset-sm-2 col-sm-8" flat  >
        <v-card-text class="mt-0 pt-0 px-0">
          <v-container  grid-list-md pt-0 pl-0 pr-0>
 
            <v-form class="pl-1 pr-1">
                <v-layout justify-center align-center class="mb-3 hidden-sm-and-down">
                  <span class="headline blue--text text--darken-3  ml-1"> Add Physician Assistant</span>
                </v-layout>
              <v-flex xs12>
                  <v-text-field v-model="pa_name" label="Name" outlined ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field v-model="pa_email" label="Email" outlined ></v-text-field>
              </v-flex>

            
              <v-flex xs12>
                <v-text-field v-model="pa_phone" type="tel"  label="Phone Number" outlined ></v-text-field>
              </v-flex>

              
                <v-flex xs12>
                  <v-text-field v-model="pa_speciality" label="Speciality" outlined ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field v-model="pa_shadowing_facility" label="Facility Name" outlined ></v-text-field>
                </v-flex>
            </v-form>


            <v-layout row class="mt-2 mb-3">
              <!-- Add PA Button -->
            
              <v-btn
                color="green"
                @click="addPaInfo"
                
                block
                large
                :disabled="checkAddPa"
              >
              
                <span class="white--text"> Save</span>
              </v-btn>
              <!-- Canel Button -->
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
     <!-- Back Button -->
    <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>



   

     
  </div>

</template>

<script>
  export default {
     data() {
      return {
        modal: false,
        alert: false,
        AddAddPaInfoDialog: false,
        pa_name : '',
        pa_speciality: '',
        pa_email: '',
        pa_phone: '',
        pa_shadowing_facility: '',
        mask: '##:##',

      }
    },
    methods: {
      back() {
        this.$router.push('/dashboard/pashadowing');
      },
      backDesktop () {
        this.$router.push('/dashboard');
      },
      addPaInfo () {
        const paInfo = {
          pa_name: this.pa_name,
          pa_speciality: this.pa_speciality,
          pa_email: this.pa_email,
          pa_phone: this.pa_phone,
          pa_shadowing_facility: this.pa_shadowing_facility,
        }
        this.AddAddPaInfoDialog = false
        this.$store.dispatch('setAddPaInfo', paInfo)
        this.$router.go('-1')
        
        this.pa_name = '',
        this.pa_speciality = '',
        this.pa_email = '',
        this.pa_phone = '',
        this.pa_shadowing_facility = ''
      }
    },
    computed : {
      user () {
        return this.$store.getters.user
      },
      checkAddPa () {
          if(this.pa_name === '' ) {
          return true
        } else {
          return false
        }
      }
    },
  }
</script>

<style scoped>
   .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;
    
  }

   #buttonShadow {
    box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
  }

.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}

.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.wrap {
  margin-top:8vh !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/PaShadowingHours/AddPaShadowing.vue